import React, {useState} from 'react';
import styles from './Members.scss';
import Close from '@material-ui/icons/Close';
import UntrackModal from '../Modal/UntrackModal/UntrackModal';
import PropTypes from 'prop-types';

const SimpleTrackItem = (props) => {

  const {linkSrc, linkName, untrack, isPropertyUntrackModal} = props;

  const [showUntrackModal, setShowUntrackModal] = useState(false);

  const toggleUntrackModal = () => {
    setShowUntrackModal(!showUntrackModal);
  };

  const untrackItem = () => {
    untrack();
    toggleUntrackModal();
  };

  return (
    <div className="d-flex justify-content-between align-items-center pt-4 pb-4">
      <a href={linkSrc}
        target="_blank"
        rel="noreferrer">
        {linkName}
      </a>
      <div className={styles.untrackLabel} onClick={() => toggleUntrackModal()} title="Remove notification">Untrack <Close /></div>
      <UntrackModal
        isPropertyUntrackModal={isPropertyUntrackModal}
        showModal={showUntrackModal}
        handleCloseModalChange={() => toggleUntrackModal()}
        handleUntrackButtonClick={() => untrackItem()}/>
    </div>
  );
};

SimpleTrackItem.propTypes = {
  linkSrc: PropTypes.string,
  linkName: PropTypes.string,
  untrack: PropTypes.func,
  isPropertyUntrackModal: PropTypes.bool,
};

export default SimpleTrackItem;